import React, { useState } from "react";
import { BookOpenIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import { OTHER_STORE_GUIDES } from "../../visoria/guides";
import { renderBlocks } from "../../visoria/components/OtherStoreGuide";

const GUIDES = {
  nintendo: {
    accountUrl: "https://accounts.nintendo.com/profile/edit",
    codeName: "eShop",
    titles: ["Как активировать код", "Как купить игру в eShop"],
  },
  playstation: {
    accountUrl: null,
    codeName: "PSN",
    titles: ["Как активировать код", "Как купить игру в PlayStation Store"],
  },
};

function Steps({ steps }) {
  return (
    <ol className="ms-5 list-decimal space-y-0.5 text-gray-700 dark:text-gray-300">
      {steps.map((step, index) => (
        <li key={index}>{renderBlocks(step)}</li>
      ))}
    </ol>
  );
}

/** Выдвижная инструкция: регион аккаунта, активация кода и покупка игры в магазине. */
function BuyGuide({ label, storeId = "nintendo" }) {
  const [open, setOpen] = useState(false);
  const { accountUrl, codeName, titles } = GUIDES[storeId];
  const sections = OTHER_STORE_GUIDES[storeId].sections.filter((section) =>
    titles.includes(section.title),
  );
  const accountRegion = accountUrl ? (
    <a href={accountUrl} target="_blank" rel="noreferrer" className="underline hover:no-underline">
      регионом вашего аккаунта
    </a>
  ) : (
    "регионом вашего аккаунта"
  );

  return (
    <div className="mt-3">
      <button
        type="button"
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
        className="mx-auto flex items-center gap-1.5 text-sm font-medium text-indigo-600 hover:underline dark:text-indigo-400"
      >
        <BookOpenIcon className="h-4 w-4" />
        Инструкция: как купить игру
        <ChevronDownIcon
          className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      <div
        className={`grid transition-[grid-template-rows] duration-300 ${
          open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        }`}
      >
        <div className="overflow-hidden">
          <div className="mt-3 space-y-4 rounded-lg bg-gray-50 p-4 text-sm dark:bg-[#222222]">
            <p className="rounded-md bg-amber-50 px-3 py-2 font-medium text-amber-800 dark:bg-amber-900/30 dark:text-amber-200">
              ‼️ Проверьте, что код совпадает с {accountRegion}
              {label ? ` — здесь коды ${codeName} региона ${label}.` : "."}
            </p>

            {sections.map((section) => (
              <section key={section.title}>
                <h4 className="mb-1.5 font-semibold text-gray-900 dark:text-white">
                  {section.title}
                </h4>
                {section.methods?.map((method) => (
                  <div key={method.title} className="mb-2">
                    <div className="mb-0.5 font-medium text-gray-800 dark:text-gray-200">
                      {method.title}
                    </div>
                    <Steps steps={method.steps} />
                  </div>
                ))}
                {section.steps ? <Steps steps={section.steps} /> : null}
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BuyGuide;
